import { Button as MuiButton, makeStyles, Tooltip } from "@material-ui/core";
import { ButtonProps as MuiButtonProps } from "@material-ui/core/Button";
import { createStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import * as React from "react";

import {
    UnusedMuiEvents,
    UnusedMuiStandardProps,
    UnusedAriaProps,
} from "../types";

import { RelodeTheme } from "../styles";
import { MergeTypes } from "../utils";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {},
            rounded: {
                borderRadius: 24,
            },
        }),
    { name: "Button" }
);

export type ButtonProps = {
    component?: string;
    rounded?: boolean;
    target?: string;
} & Omit<
    MuiButtonProps,
    UnusedMuiEvents | UnusedMuiStandardProps | UnusedAriaProps
> &
    Pick<
        MuiButtonProps,
        | "onClick"
        | "variant"
        | "type"
        | "size"
        | "disableRipple"
        | "disableFocusRipple"
        | "style"
    >;

export const Button = (props: ButtonProps) => {
    const {
        variant = "contained",
        className: classNameProp,
        rounded = false,
        children,
        disabled,
        title,
        ...other
    } = props;

    const classes = useStyles({});

    const buttonClassNames = classnames(
        { [classes.rounded]: rounded },
        classNameProp
    );

    return (
        <Tooltip placement="bottom-start" title={(!disabled && title) || ""}>
            <MuiButton
                {...other}
                variant={variant}
                disabled={disabled}
                className={buttonClassNames}
            >
                {children}
            </MuiButton>
        </Tooltip>
    );
};
